$(function () {
  
  window.onscroll = function(){ 
    let t = document.documentElement.scrollTop || document.body.scrollTop;  
    if( t>=60 ) { 
        $('.h_nav_par').addClass('h-top')
      }else {
        $('.h_nav_par').removeClass('h-top')
      }
    }

  $('.list-menu>li').hover(function(){
    $(this).find('.h-list').show()
  })  
  
  $('.header__icons .header__icon').click(function(){
    $('.header__icons .modal__content').addClass('search-cont-b')
    
  })
  $('.header__icons .modal__close-button').click(function(){
    $('.header__icons .modal__content').removeClass('search-cont-b')
  })

  
  // cut
  $('.mu_switch').click(function(){
    $('#ProductGridContainer').removeClass('ProductGridContainer-cp')
    $('#ProductGridContainer').find('.product_description').css('display','none')
     $(this).addClass('mu_bg').siblings().removeClass('mu_bg')
    let index=$(this).index()
    
    if(index==2){
      $('#product-grid').removeClass('grid--1-col-desktop')
      $('#product-grid').removeClass('grid--3-col-desktop')
      $('#product-grid').removeClass('grid--2-col-desktop')
      $('#product-grid').addClass('grid--4-col-desktop')
    }else if(index==0){
      $('#product-grid').removeClass('grid--1-col-desktop')
      $('#product-grid').removeClass('grid--3-col-desktop')
      $('#product-grid').removeClass('grid--4-col-desktop')
      $('#product-grid').addClass('grid--2-col-desktop')
    }else if(index==1){
      $('#product-grid').removeClass('grid--1-col-desktop')
      $('#product-grid').removeClass('grid--4-col-desktop')
      $('#product-grid').removeClass('grid--2-col-desktop')
      $('#product-grid').addClass('grid--3-col-desktop')
    }
  })
  
  $('.mu_switch0').click(function(){
    $('#ProductGridContainer').addClass('ProductGridContainer-cp')
    $('.product_description').css('display','block')
     $(this).addClass('mu_bg').siblings().removeClass('mu_bg')
  })

  // tab栏置顶
  $(".station-tabs-tabtitle").click(function (){
    let offset=$('.station-tabs-product-block').offset()
   $('body,html').animate({
     scrollTop:offset.top-60
   })
  })
 
})